export default __webpack_public_path__ + "images/6106104bc3d280f0f3869a75aa0df72b.png";